import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";

import EventSlots from "./pages/Event&Slots";
import Login from "./pages/Login";
import TicketScanner from "./pages/TicketScanner";
import Status from "./pages/Status";
import { AppProvider } from "./context/appContext";
import React from "react";

function App() {
    React.useEffect(() => {
        function setFullHeight() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
        setFullHeight();
        window.addEventListener('resize', setFullHeight);

        // Cleanup event listener on unmount
        return () => window.removeEventListener('resize', setFullHeight);
    }, []);

    return (
        <AppProvider>
            <Router>
                <div className="App">
                    <div
                        className="w-full flex col-flex justify-center items-center br-8 transform-center top left bc-white fixed "
                        style={{
                            maxWidth: "480px",
                            minWidth: "340px",
                            minHeight: "calc(var(--vh, 1vh) * 100)",
                            height: "100%",
                            border: "1px solid #e2e8f0",
                            overflowX: "auto",
                        }}
                    >
                        <Routes>
                            <Route path="/event-scanner/login" element={<Login />} />
                            <Route path="/event-scanner/event-slots" element={<EventSlots />} />
                            <Route path="/event-scanner/ticket-scanner/:id" element={<TicketScanner />} />
                            <Route path="/event-scanner/status/:id" element={<Status />} />
                            <Route path="/event-scanner" element={<Navigate to="/event-scanner/login" replace />} />
                        </Routes>
                    </div>
                </div>
            </Router>
        </AppProvider>
    );
}

export default App;
